import { BoxProps } from 'UIKit/Box/types'
import { useImmutableValueReference } from 'hooks/useImmutableValueReference'
import { useCallback } from 'react'
import { usePlinkoAction } from 'views/InhouseGame/Plinko/hooks'
import Sketch from '../../../Sketch'
import { plinkoSizes } from '../../config'
import useConfigGameMatter from './hooks/useConfigGameMatter'

const GameGraphic: React.FC<
  { row: number; canvasWidth: number; canvasHeight: number; onRendered: () => void } & BoxProps
> = ({ row, canvasHeight, canvasWidth, onRendered, ...props }) => {
  const { plinkos, ripples, particles, onParticleCompleted } = useConfigGameMatter({ row })
  const rowRef = useImmutableValueReference(row)
  const { finishBet } = usePlinkoAction()

  const setup = useCallback((p5: any, canvasParentRef: any) => {
    p5.createCanvas(canvasWidth, canvasHeight).parent(canvasParentRef)
    if (onRendered) onRendered()
  }, [])

  const draw = useCallback((p5: any) => {
    p5.background(25, 29, 37)
    for (let i = 0; i < ripples.length; i++) {
      if (ripples[i]) {
        ripples[i].display(p5)
        if (ripples[i].size >= plinkoSizes[rowRef.current] + 10) {
          ripples[i] = null
        }
      }
    }

    for (let i = 0; i < ripples.length; i++) {
      if (!ripples[i]) {
        ripples.splice(i, 1)
      }
    }

    for (let i = 0; i < plinkos.length; i++) {
      plinkos[i].display(p5)
    }

    for (let i = 0; i < particles.length; i++) {
      if (particles[i] != null) {
        particles[i].display(p5)

        // Case of particle falls down the ground
        if (particles[i].body.position.y >= canvasHeight - particles[i].size) {
          onParticleCompleted(particles[i], rowRef.current)
          finishBet(particles[i].bet)
          particles[i] = null
        }
      }
    }

    for (let i = 0; i < particles.length; i++) {
      if (particles[i] === null) {
        particles.splice(i, 1)
      }
    }
  }, [])

  return <Sketch setup={setup} draw={draw} {...props} />
}

export default GameGraphic
